import { WebInAppDisplaySettingsDefinition } from 'modules/graphql/types/GraphQLTemplate';

/**
 * getViewOptions
 * helper function that sets provides the possible view options for the InApp Segment Control.
 * If a version of the template does not have an inbox, then we do not include it as an option.
 */
export const getViewOptions = (hasInbox: boolean) => {
  const defaultOptions = [
    { name: 'App', key: 'app', value: 'app' },
    { name: 'Web', key: 'web', value: 'web' },
  ];
  return hasInbox
    ? [...defaultOptions, { name: 'Inbox', key: 'inbox', value: 'inbox' }]
    : defaultOptions;
};

/**
 * generatePositionStyles
 * This generates position styles for the in-app message based on the display settings of its "webInAppDisplaySettings" property.
 * The web display position is directly coupled with the in-app display position, meaning that we can make an inference
 * that based off one we know the position of the other.
 *
 * **NOTE** The styles generated from this function are directly coupled from the `generatePositionStyles` function found at:
 * `src/modules/templateEditor/EditInApp/preview/styleGenerators.tsx`. Like everything else in this module, this work exists
 * under the assumption that it is temporary. We _should_ be using the templateEditor module's preview for this module, but
 * the current template diff module does not fetch its data from grapqhl, a necessity for the templateEdit preview.
 */
export const generatePositionStyles = (
  isWebPreview: boolean,
): Record<WebInAppDisplaySettingsDefinition, Record<string, number | string>> => ({
  [WebInAppDisplaySettingsDefinition.Full]: {
    height: '100%',
    width: '100%',
  },
  [WebInAppDisplaySettingsDefinition.Center]: {
    top: '50%',
    transform: 'translate(0px, -50%)',
    insetInline: isWebPreview ? '20%' : '',
    maxHeight: '100%',
    writingMode: isWebPreview ? 'horizontal-tb' : '',
    minWidth: isWebPreview ? '60%' : '100%',
    maxWidth: isWebPreview ? '70%' : '100%',
  },
  [WebInAppDisplaySettingsDefinition.TopRight]: {
    right: 0,
    top: 0,
    maxHeight: '100%',
    minWidth: isWebPreview ? '60%' : '100%',
    maxWidth: isWebPreview ? '70%' : '100%',
  },
  [WebInAppDisplaySettingsDefinition.BottomRight]: {
    right: 0,
    bottom: 0,
    maxHeight: '100%',
    minWidth: isWebPreview ? '60%' : '100%',
    maxWidth: isWebPreview ? '70%' : '100%',
  },
});
